<template>
  <el-dialog :title="formData.id ? 'Засварлах' : 'Шинэ тайлан үүсгэх'" v-model="createReportDialog" width="70%"
    @close="handleClose">
    <div>
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="120px">
        <el-form-item label="Тайлангийн нэр" prop="name">
          <el-input v-model="formData.name" placeholder="Тайлангийн нэр оруулна уу"></el-input>
        </el-form-item>
        <el-form-item label="SQL Query" prop="query">
          <el-input
            type="textarea"
            :rows="10"
            v-model="formData.query"
            placeholder="SQL query оруулна уу. Хугацааны хувьд :startDate болон :endDate ашиглана уу. Жишээ: SELECT * FROM trackcodes WHERE createdAt BETWEEN :startDate AND :endDate"
            @blur="validateQuery">
          </el-input>
          <div style="margin-top: 10px; color: #909399; font-size: 12px;">
            <p>Анхаар: Query дотор :startDate болон :endDate placeholder-уудыг ашиглана уу.</p>
            <p>Жишээ: SELECT * FROM trackcodes WHERE createdAt BETWEEN :startDate AND :endDate</p>
          </div>
          <el-alert
            v-if="queryError"
            :title="queryError"
            type="error"
            :closable="false"
            style="margin-top: 10px;"
          />
        </el-form-item>
        <el-form-item label="Идэвхтэй эсэх" prop="is_active">
          <el-switch v-model="formData.is_active"></el-switch>
        </el-form-item>
        <el-form-item>
          <el-button @click="handleClose">Хаах</el-button>
          <el-button type="primary" @click="submitForm">Хадгалах</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import services from '@/services'
import { ElMessage } from 'element-plus'
import {
  mapActions,
  mapState
} from 'vuex'

export default {
  name: 'ReportDialog',
  computed: {
    ...mapState(['createReportDialog'])
  },
  props: {
    selectedReport: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      formData: {
        name: '',
        query: '',
        is_active: true
      },
      rules: {
        name: [{
          required: true,
          message: 'Тайлангийн нэр оруулна уу',
          trigger: 'blur'
        }],
        query: [{
          required: true,
          message: 'SQL query оруулна уу',
          trigger: 'blur',
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('SQL query оруулна уу'))
            } else {
              const trimmedQuery = value.trim().toUpperCase()
              if (!trimmedQuery.startsWith('SELECT')) {
                callback(new Error('Зөвхөн SELECT query зөвшөөрөгдөнө'))
              } else {
                const dangerousCommands = ['DROP', 'DELETE', 'UPDATE', 'INSERT', 'ALTER', 'TRUNCATE', 'EXEC', 'EXECUTE']
                for (const cmd of dangerousCommands) {
                  if (trimmedQuery.includes(cmd)) {
                    callback(new Error(`Аюултай командыг ашиглахыг хориглоно: ${cmd}`))
                    return
                  }
                }
                callback()
              }
            }
          }
        }]
      },
      queryError: ''
    }
  },
  watch: {
    selectedReport: {
      immediate: true,
      handler (newValue) {
        if (newValue && newValue.id) {
          this.formData = {
            ...newValue
          }
        } else {
          this.formData = {
            name: '',
            query: '',
            is_active: true
          }
        }
      }
    }
  },
  methods: {
    ...mapActions(['setCreateReportDialog']),
    handleClose () {
      this.formData = {
        name: '',
        query: '',
        is_active: true
      }
      this.setCreateReportDialog(false)
    },
    validateQuery () {
      if (!this.formData.query) {
        this.queryError = ''
        return
      }

      const trimmedQuery = this.formData.query.trim().toUpperCase()

      if (!trimmedQuery.startsWith('SELECT')) {
        this.queryError = 'Зөвхөн SELECT query зөвшөөрөгдөнө'
        return
      }

      const dangerousCommands = ['DROP', 'DELETE', 'UPDATE', 'INSERT', 'ALTER', 'TRUNCATE', 'EXEC', 'EXECUTE']
      for (const cmd of dangerousCommands) {
        if (trimmedQuery.includes(cmd)) {
          this.queryError = `Аюултай командыг ашиглахыг хориглоно: ${cmd}`
          return
        }
      }

      this.queryError = ''
    },
    async submitForm () {
      // Query validation
      this.validateQuery()
      if (this.queryError) {
        ElMessage.error(this.queryError)
        return
      }

      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          try {
            let response
            if (this.formData.id) {
              response = await services.update('reports', this.formData)
            } else {
              response = await services.create('reports', this.formData)
            }
            if (response && response.type === 'success') {
              ElMessage.success('Амжилттай хадгалагдлаа!')
              this.handleClose()
              this.$emit('reload')
            } else {
              ElMessage.error('Алдаа гарлаа!')
            }
          } catch (error) {
            console.error('API Request Error:', error.message)
            ElMessage.error(error.message || 'Алдаа гарлаа!')
          }
        } else {
          console.log('Алдаа гарлаа, шаардлагатай талбаруудыг бөглөнө үү')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
  .el-form {
    max-width: 100%;
    margin: 0 auto;
  }
</style>
